import ContactCard from 'components/ContactsList/ContactCard/container';

export default ContactCard;
